export default __webpack_public_path__ + "media/images/elements/13-1681d34563cb21fe7ed9f61fa6d32aa0.png";